import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Form } from 'reactstrap';
import { useMutation } from '@apollo/client';
import query from '../../query';
import InputText from '../../components/inputText/InputText';
import Button from '../../components/button/Button';
import Loader from '../../components/loader/Loader';
import Logo from '../../components/logo/Logo';
import {Link} from 'react-router-dom';
import { clearStoredMfaMetadata } from './MfaUtils';

export default function ShowVerifyIdentity() {
  const [mfaCode, setMfaCode] = useState('');
  const [error, setError] = useState(null);
  const history = useHistory();

  const userId = parseInt(localStorage.getItem('user_auth_id'), 10);
  const communicationMethod = localStorage.getItem('communicationMethodMfa');

  const [verifyMfaCodeMutation, { loading }] = useMutation(query.verifyMfaCode, {
    errorPolicy: 'all'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await verifyMfaCodeMutation({
        variables: {
          userId,
          mfaCode,
          communicationMethod
        }
      });

      if (data?.verifyMfaCode?.success) {
        clearStoredMfaMetadataInf()
        history.push('/');
      } else if (data?.verifyMfaCode?.errorMessage) {
        setError(data.verifyMfaCode.errorMessage);
      } else {
        setError('Invalid code. Try again.');
      }
    } catch (err) {
      console.error('[verifyMfaCode] Error:', err);
      setError('Something went wrong. Try again.');
    }
  };

  function clearStoredMfaMetadataInf() {
    localStorage.removeItem('communicationMethodMfa');
    clearStoredMfaMetadata()
  }

  return (
    <div className="mfa-wrapper">
      <Container>
        <Form onSubmit={handleSubmit} className="py-1 py-lg-5 align-element-center">
          <div className="col-lg-4 col-12 col-md-7 m-auto text-center">
            <Logo />
            {loading && <Loader />}
            <h2 className="mb-3 mt-3">
              <b>Verify Your Identity</b>
            </h2>
            <p className="text-muted mb-4">
              <b>Please enter the code you received for Multi-Factor Authentication (MFA).</b>
            </p>

            <InputText
              type="text"
              name="mfa_code"
              id="mfa_code"
              placeholder="Enter your MFA verification code"
              maxLength={6}
              onChange={(e) => setMfaCode(e.target.value)}
              value={mfaCode}
              required={true}
              style={{ textAlign: 'center' }}
            />

            {error && <b><p className="text-danger mt-2">{error}</p></b>}

            <div className="mt-4">
              <Button
                type="submit"
                title={loading ? 'Verifying...' : 'Confirm'}
                disabled={!mfaCode.trim() || loading}
              />
            </div>

            <div className="mt-4">
              <Link
                href="#"
                style={{ color: '#ff5a00', textDecoration: 'underline' }}
                onClick={(e) => {
                  e.preventDefault();
                  history.push('/showMultifactorAuthentication');
                }}
              >
                Didn't receive the code or having trouble? Click here to resend.
              </Link>
            </div>
          </div>
        </Form>
      </Container>
    </div>
  );
}
